var cx = require('classnames');
var moment = require('moment');
var sprintf = require('sprintf-js').sprintf;

var React = require('react');

var GenericForm = React.createClass({
    propsTypes: {
        buttons: React.PropTypes.arrayOf(React.PropTypes.node),
        cancelButtonClasses: React.PropTypes.object,
        cancelHandler: React.PropTypes.func,
        disableButtons: React.PropTypes.bool,
        horizontal: React.PropTypes.number.isRequired,
        showCancel: React.PropTypes.bool,
        submitButtonClasses: React.PropTypes.object,
        submitButtonText: React.PropTypes.node.isRequired,
        submitHandler: React.PropTypes.func
    },
    statics: {
        /**
         * Calculates the class requirements for labels and the form container
         * divs given a specific label width.
         */
        getClasses: function (labelWidth, colSize) {
            colSize = colSize || 'md';

            var containerWidth = 12 - labelWidth;

            var containerClasses = {};
            containerClasses[sprintf("col-%s-%s", colSize, containerWidth)] = true;

            var labelClasses = {
                "control-label": true
            };
            labelClasses[sprintf("col-%s-%s", colSize, labelWidth)] = true;

            var offsetContainer = {};
            offsetContainer[sprintf("col-%s-offset-%s", colSize, labelWidth)] = true;
            offsetContainer[sprintf("col-%s-%s", colSize, containerWidth)] = true;

            return {
                container: containerClasses,
                label: labelClasses,
                offset: offsetContainer
            };
        }
    },

    getDefaultProps: function () {
        return {
            buttons: [],
            cancelButtonClasses: { btn: true, "btn-default": true },
            disableButtons: false,
            horizontal: 3,
            submitButtonClasses: { btn: true, "btn-success": true }
        }
    },
    render: function () {
        var classes = GenericForm.getClasses(this.props.horizontal);

        return <section className="form-horizontal">
            {this.props.children}
            <div className="form-group">
                <div className={cx(classes.offset)}>
                    <div className="btn-group">
                    <button className={cx(this.props.submitButtonClasses)} disable={this.props.disableButtons} onClick={this._submit}>{this.props.submitButtonText}</button>
                    {this.props.showCancel && <button className={cx(this.props.cancelButtonClasses)} disable={this.props.disableButtons} onClick={this._cancel}>{this.props.cancelButtonText}</button>}
                    {this.props.buttons}
                    </div>
                </div>
            </div>
        </section>;
    },
    _cancel: function (e) {
        if (this.props.cancelHandler) {
            this.props.cancelHandler(e);
        }
    },
    _submit: function (e) {
        if (this.props.submitHandler) {
            this.props.submitHandler(e);
        }
    }
})
module.exports = GenericForm;



// WEBPACK FOOTER //
// ./app/components/Form/GenericForm.js